export function asHtmlElement<T extends keyof HTMLElementTagNameMap>(element: Element | null, tagName: T)
{
    if (!element) { return null; }
    if (element.tagName.toLowerCase() !== tagName.toLowerCase()) { return null; }
    return element as HTMLElementTagNameMap[T];
}